// Clean rebuild – npm normalized 2026-03-05
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register service worker in production only, never in iframes or preview hosts
if ("serviceWorker" in navigator) {
  const isInIframe = (() => {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  })();

  const isPreviewHost =
    window.location.hostname.includes("id-preview--") ||
    window.location.hostname.includes("lovableproject.com");

  if (!isInIframe && !isPreviewHost) {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  } else {
    // Cleanup any stale service workers in preview/iframe contexts
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((r) => r.unregister())
    );
  }
}

createRoot(document.getElementById("root")!).render(<App />);
